import React from "react";

import { Container } from "@components/Container/Container";

import { Swiper, SwiperSlide } from "swiper/react";

import styles from "./styles.module.scss";
import stylesHeading from "@components/Heading/styles.module.scss";
import { ImageField } from "@helpers/interfaces/image";
import { ArticleBox } from "@components/ArticleBox/ArticleBox";
import { LinkField } from "@helpers/interfaces/link";
import Anime from "react-anime";
import { animeChildrenProps } from "@helpers/animations";
import { useInView } from "react-intersection-observer";
import { Heading } from "@components/Heading/Heading";
import { Link } from "@components/Link/Link";
import { Box } from "@components/Box/Box";
import { VideoField } from "@helpers/interfaces/media";

interface spotProps {
  Key: string;
  Headline: string;
  Image: ImageField;
  Video?: {
    Video: VideoField;
  };
  Link: LinkField;
  ShowPlayIcon: boolean;
  TeaserText: string;
}

export interface ArticleSpotsWithSliderProps {
  headline: string;
  spots: spotProps[];
  large: boolean;
  link: {
    Name?: string;
    Url?: string;
  };
}

const ArticleSpotsWithSlider: React.FC<ArticleSpotsWithSliderProps> = ({
  headline,
  spots,
  large,
  link,
  ...props
}) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
  });
  const imageWidth = large ? [270, 300, 300, 310] : [150, 200, 200, 210];
  const imageHeight = large ? [152, 169, 169, 174] : [84, 112, 112, 118];

  const swiperSlideStyle = large ? styles.swiperSlideLarge : styles.swiperSlide;

  globalThis.console.log("inView", inView);

  return (
    <div ref={ref} {...props}>
      <Container>
        {headline && (
          <Heading as="h2" className={stylesHeading.headingRibbon}>
            {headline}
          </Heading>
        )}
        <Swiper slidesPerView="auto" className={styles.swiperContainer}>
          {spots &&
            spots.map((spot: spotProps, index: number) => {
              const animateEachChild = {
                ...animeChildrenProps,
                ...{ delay: (index * 100) / 1.5 },
                ...(inView ? { autoplay: true } : { autoplay: false })
              };

              return (
                <SwiperSlide key={spot.Key} className={swiperSlideStyle}>
                  <Anime {...animateEachChild}>
                    <ArticleBox
                      image={spot.Image}
                      imageWidth={imageWidth}
                      imageHeight={imageHeight}
                      {...(spot.Video && { video: spot.Video.Video })}
                      section={spot.Headline}
                      title={spot.TeaserText}
                      {...(spot.Link && {
                        url: spot.Link.Url,
                        target: spot.Link.Target
                      })}
                      showPlayIcon={spot.ShowPlayIcon}
                      sectionVariant="medium"
                      fontSize="small"
                    />
                  </Anime>
                </SwiperSlide>
              );
            })}
        </Swiper>
        {link && (
          <Box className={styles.linkContainer}>
            <Link
              href={link.Url}
              icon={true}
              {...(link.Target && { target: link.Target })}
            >
              {link.Name}
            </Link>
          </Box>
        )}
      </Container>
    </div>
  );
};
export { ArticleSpotsWithSlider };
